import gsap from 'gsap'
import { forEach } from 'lodash'

import { batchRevealAnimation } from './shared'
import { Animation } from '@/types'

export const productIconListRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const buttons = selector('[data-motion-button]')

  let buttonsBatchAnimation: ScrollTrigger[]
  if (buttons.length > 0) {
    buttonsBatchAnimation = batchRevealAnimation({
      targets: buttons,
      reverse,
      delay,
      stagger: {
        amount: 0.24
      }
    })
  }

  return () => {
    forEach(buttonsBatchAnimation || [], (animation) => animation.kill())
  }
}
